import { ComponentExtensionRegistry } from '~/plugins/ComponentExtensionRegistry';
import ExtendCaselistPlaceholders from './components/ExtendCaselistPlaceholders';

export const initPlugin = (): void => {
  ComponentExtensionRegistry.register('monthlyReport.format.placeholders', {
    id: 'extend-create-caselist-placeholders',
    component: ExtendCaselistPlaceholders,
    order: 100,
    featureFlag: 'ExtendCreateCaselist',
  });
};

// Parent-child relationship resolved from config/tenants/default.json via API.
// ClientPluginLoader uses this to determine initialization order.
export const parentPlugin = 'MonthlyReportCustomization';

export const resources_ja: Record<string, string> = {
  'function.ExtendCreateCaselist': '月報案件一覧拡張',
};
